export default "__VITE_ASSET__G$5UjpKS__"